import Image from 'next/image';
import { Spacer } from '../../../parts/Spacer';
import { UnextLogoAndTypeDarkJetblackImage } from '../../../parts/svgImages/UnextLogoAndTypeImage';
import { MobileBanner } from './MobileBanner';
import Background from './footer_background.svg?url';
import type { Config } from 'u-next/config';

export const Footer: React.FC<{
  hasRakutenBanner: boolean;
  config?: Config;
}> = ({ hasRakutenBanner, config }) => (
  <footer className="relative min-h-48">
    <Image
      alt=""
      src={Background}
      fill
      className="object-cover"
      priority={false}
    />
    <Spacer spacing={16} />
    <div className="relative">
      <UnextLogoAndTypeDarkJetblackImage alt="" className="mx-auto h-6" />
      {hasRakutenBanner && config && (
        <>
          <Spacer spacing={8} />
          <MobileBanner config={config} />
          <Spacer spacing={16} />
        </>
      )}
    </div>
  </footer>
);
